import React, { useState, useEffect } from 'react';
import "./pages.css";
import * as FeatherIcon from "react-feather";
import Button from 'react-bootstrap/Button';
import { Alert } from 'react-bootstrap'; // To display success/failure message
import { asknewsquestion } from '../../../services/authService';


export default function AskQuestion() {
  // State variables
  const [email, setEmail] = useState('');
  const [news_title, setNewsTitle] = useState('');
  const [newsUrl, setNewsUrl] = useState('');
  const [ctatype, setCTAType] = useState('');
  const [userId, setUserId] = useState('');
  const [newsId, setNewsId] = useState('');
  const [post_content, setPostContent] = useState('');
  const [message, setMessage] = useState(''); // For displaying success/failure message
  const [messageType, setMessageType] = useState(''); // For success or failure message type
  const [isPostContentEmpty, setIsPostContentEmpty] = useState(false); 

  // Helper function to decode Base64 URL-safe strings
  const base64UrlDecode = (input) => {
    let base64 = input.replace(/-/g, '+').replace(/_/g, '/');  // Convert to standard Base64
    const padding = base64.length % 4;
    if (padding) {
      base64 += '='.repeat(4 - padding);  // Add padding
    }
    return atob(base64);  // Decode Base64
  };

  // Function to extract and decode URL parameters
  const extractUrlParams = () => {
    const urlParams = new URLSearchParams(window.location.search);

    // Decode and set parameters
    const emailParam = urlParams.get('email');
    const newsTitleParam = urlParams.get('news_title');
    const newsUrlParam = urlParams.get('news_url');
    const ctatypeParam = urlParams.get('cta_type');
    const userIdParam = urlParams.get('user_id');
    const newsIdParam = urlParams.get('news_id');

    // Decode Base64 email if needed
    if (emailParam) {
      const decodedEmail = base64UrlDecode(emailParam);
      setEmail(decodedEmail);
    }

    // Decode the news title if it's Base64 encoded
    if (newsTitleParam) {
      const decodedNewsTitle = base64UrlDecode(newsTitleParam);
      setNewsTitle(decodedNewsTitle);  // Set decoded news title
    }

    // Decode other URL parameters
    const decodedNewsUrl = decodeURIComponent(newsUrlParam || '');
    const decodedCtaType = decodeURIComponent(ctatypeParam || '');
    const decodedUserId = userIdParam ? base64UrlDecode(userIdParam) : ''; // Decode user_id if it exists
    const decodedNewsId = newsIdParam ? base64UrlDecode(newsIdParam) : ''; // Decode news_id if it exists

    // Set other decoded values
    setNewsUrl(decodedNewsUrl);
    setCTAType(decodedCtaType);
    setUserId(decodedUserId);
    setNewsId(decodedNewsId);
  };

  // UseEffect to extract params when the component mounts
  useEffect(() => {
    extractUrlParams();
  }, []);

  // Handle textarea change
  const handleTextareaChange = (event) => {
    setPostContent(event.target.value);
    setIsPostContentEmpty(false);
  };

  // Handle form submission
  const handleSubmit = async () => {
    // Display a loading message or reset any previous message
    setMessage('');
    setMessageType('');
    // Check if post_content is empty
    if (!post_content.trim()) {
      setIsPostContentEmpty(true); // Show error message below textarea
      return; // Stop the submission if textarea is empty
    }

    // Data to be submitted
    const Params = {
      email,
      news_title,
      ctatype,
      userId,
      newsId,
      post_content
    };

    try {     

      let my_data = await asknewsquestion(Params);             
      if(my_data.status == 201) {
        // On success
        setMessageType('success');
        setMessage('Your question has been submitted successfully!');
      } else {
        // On failure (invalid data or API error)
        const errorData = my_data.result.message;
        setMessageType('danger');
        setMessage(errorData.message || 'Please Enter Question.');
      }
    } catch (error) {
      // Handle any network errors or exceptions
      console.error('Error submitting form:', error);
      setMessageType('danger');
      setMessage('An error occurred while submitting the form.');
    }
  };

  return (
    <div>
      <div className="ask_question_wrapper mt-4 d-none1">
        <div className="container">
          <div className="custom_card_block">
            <div className="ask_question_block">
              <div className="question_head_block">
                <h5 className="question_head">ASK A QUESTION</h5>
              </div>
              
              <div className="question_text_block">
                {/* Display success or failure message */}
                 {message  ? (
                    <Alert variant={messageType} className="mt-3">
                      {message}
                    </Alert>
                  ) : (
                    <div>
                      <h5 className="question_head">NEWS TITLE</h5>
                      {/* Now the decoded newsTitle will be displayed */}
                      <p className="text_up">{news_title}</p>
                      <p className="text_down">PRECISELY, I WOULD LIKE YOU TO HELP ME WITH THE FOLLOWING</p>
                      <div className="form">
                        <textarea
                          name="post_content"
                          className="textarea_cutom"
                          placeholder="What's on Your Mind? For e.g. I would like to increase my Digitalization business revenue by 25% in the next 3 years"
                          value={post_content}
                          onChange={handleTextareaChange}
                        />
                        {isPostContentEmpty && (
                          <p className="text-danger" style={{ fontSize: '12px' }}>
                            Please enter your question.
                          </p>
                        )}
                        <Button variant="primary" className="submit_btn" onClick={handleSubmit}>
                          Submit <FeatherIcon.ArrowRight className="fa" />
                        </Button>
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
